import If from 'mrf/utils/If.js'

console.warn("The 'view/IF' component is deprecated, please use 'utils/If' instead.")
const IF = If;

export default IF;